import _ from 'lodash';
import Logger from './Logger';

const TYPE_STRING = typeof('');
const TYPE_ARRAY = typeof([]);

/**
 * Splits the string by delimeter into a list
 *
 * @param {string|Array} string
 * @param {Array} replacements
 * @returns {Array}
 */
const stringToListSanitize = (string, replacements) => {
  const delim = ' ';
  for (let replacement of replacements) {
    string = string.split(replacement).join(delim);
  }

  const stringAsList = (string.split(delim) || []);
  return _.filter(_.map(stringAsList, e => e.trim(), e => e.trim().length !== 0));
};

export const StringUtils = {

  /**
   * Validate emails
   *
   * @param {string|Array} stringOrArray
   * @param {Array} [replacements = [',']] array of strings to replace against
   * @returns {Array<string>}}
   */
  stringToList (stringOrArray, replacements = [',']) {
    let list;
    if (typeof stringOrArray === TYPE_STRING) {
      list = stringToListSanitize(stringOrArray, replacements);
    } else if (typeof stringOrArray === TYPE_ARRAY) {
      list = stringOrArray;
    } else {
      Logger.assert('stringOrArray parameter must be a string or an array');
    }

    return list;
  },

  /**
   * Do the two domains match
   *
   * @param {string} one - email address
   * @param {string} two - email address
   * @return {boolean}
   */
  doesEmailDomainMatch (one, two) {
    // Check that email domains match
    const oneAtSignIndex = one.indexOf('@');
    const twoAtSignIndex = two.indexOf('@');
    if (oneAtSignIndex >= 0 && twoAtSignIndex >= 0) {
      // Get domain name
      const oneDomain = one.substring(oneAtSignIndex);
      const twoDomain = two.substring(twoAtSignIndex);
      return oneDomain === twoDomain;
    } else {
      // Not an email?
      return false;
    }
  },
  /**
   *
   * Abbreviate a number with "K" if it is larger than 9,999
   *
   * @param {number} a number that could potentially be more than 4 digits
   * @returns {string } the number of thousands, rounded to 1 decimal, followed by the "K"
   */
  roundThousands (num) {
    let rounded;
    if (num > 9999 || num < -9999) {
      rounded = Number.parseFloat((num / 1000).toFixed(1));
      return rounded.toString() + 'K';
    } else {
      return num;
    }
  }
};
